
export interface DifferenceProps {
    p: string;
    o?: string;
    n?: string;
}

/**
 * Differenz von Attributen
 */
export class Difference {

    /**
     * Object property name
     */
    p: string;
    /**
     * Old value
     */
    o: string;
    /**
     * New value
     */
    n: string;

    constructor(props?: DifferenceProps) {
        if (props) {
            Object.assign(this, props);
        }
    }

}

